import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { translate } from 'helpers/intl';
import messages from 'containers/MRHDetailsPage/messages';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { StyledShortBody } from 'containers/MRhDashboard/services/styles';
import { sanlamDarkGrayishBlue } from 'Material-UI/colors';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import {
  StyledtBlocWrapper,
  SizedSmallSectionHeader,
  StyledBodyText,
} from 'containers/MRHDetailsPage/SuiviSinistreMrh/styles';
import { sanlamVeryLightgray } from 'Material-UI/colors';
import ChevronCardButton from 'components/ChevronCardButton';
import { contactMrh } from 'utils/globalConst';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { reversedNum } from 'utils/string';
import { StyledLink } from 'containers/MRhDashboard/services/styles';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { getAgents } from 'store/geolocAgent/actions';
import { getAgentSelector } from 'store/geolocAgent/selectors';

const SuivreSinistreMrhTab = ({
  agentInfo,
  ...props
}: {
  intl: IntlShape;
  agentInfo: { FAX: string; AGT_EMAIL: string };
  getAgents: Function;
}) => {
  /* eslint-disable */
  useEffect(() => {
    getAgents();
  }, [getAgents]);
  /* eslint-enable */
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const items = [
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_DETAILS}
          label="Suivi de mes sinistres _Contacter le service client"
        >
          <StyledLink href={`tel:${contactMrh.serviceFr}`}>
            <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
              {translate(messages.contact_service_mrh, props)}
            </StyledShortBody>
            <StyledShortBody color="#6D2C8F" weight="500">
              {reverse ? contactMrh.serviceAr : contactMrh.serviceFr}
            </StyledShortBody>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'CallService',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_DETAILS}
          label="Suivi de mes sinistres_Contacter mon agent par tel"
        >
          <StyledLink href={`tel:${agentInfo && agentInfo.FAX}`}>
            <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
              {translate(messages.agent_service_mrh, props)}
            </StyledShortBody>
            <StyledShortBody color="#6D2C8F" weight="500">
              {agentInfo && reverse
                ? reversedNum(agentInfo.FAX)
                : agentInfo && agentInfo.FAX}
            </StyledShortBody>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'AgentCall',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_DETAILS}
          label="Suivi de mes sinistres _Contacter mon par email "
        >
          <StyledLink href={`mailto:${agentInfo && agentInfo.AGT_EMAIL}`}>
            <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
              {translate(messages.email_contact_mrh, props)}
            </StyledShortBody>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'AgentEmail',
    },
  ];
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.MRH_ACCUEIL}
      label="Suivi de mes sinistres_Tab 1_Suivi de mes sinistres"
    >
      <StyledtBlocWrapper height="auto">
        <Grid item>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate({ ...messages.title_suivi_sinistre_mrh }, props)}
          </SizedSmallSectionHeader>
        </Grid>
        <Grid item>
          <StyledBodyText weight="300">
            {translate({ ...messages.content_suivi_sinistre_mrh }, props)}
          </StyledBodyText>
        </Grid>
        <Grid container spacing={3}>
          {items.map((item: any, index: number) => (
            <Grid item xs={matches ? 12 : 6} key={index}>
              <ChevronCardButton
                borderColor={sanlamVeryLightgray}
                item={item}
                clickHandler={() => {}}
                deleteHoverBorder={true}
              />
            </Grid>
          ))}
        </Grid>
      </StyledtBlocWrapper>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    agentInfo: { FAX: string; AGT_EMAIL: string };
  }
>({
  agentInfo: getAgentSelector,
});

const mapDispatchToProps = {
  getAgents,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(SuivreSinistreMrhTab));
